<h5 class="modal-title break-all">
  <span class="me-3">{{prefix}}</span>
  <i class="{{viewIcon$ | async}} align-self-center"  aria-hidden="true"></i>&nbsp;
  <span>{{(view$ | async)?.name}}</span>
</h5>
